<div *ngIf="paging != null && (paging.hasNext || paging.hasPrevious)" class="paging">
    <a *ngIf="paging.hasPrevious" (click)="gotToPage(paging.currentPage - 1)">&#60; Previous</a>
    &nbsp;&nbsp;
    <a *ngIf="paging.hasNext"  (click)="gotToPage(paging.currentPage + 1)">Next &#62;</a>
    <span *ngIf="showPageLabel">
        &nbsp;&nbsp;Page {{ paging.currentPage }} of {{ paging.totalPages }}
    </span>
</div>
